"use client";

import { useEffect, useState } from "react";

import LoginComponent from "components/Login/LoginComponent";
import TutorialDesktop from "components/Login/TutorialDesktop";
import TutorialMobile from "components/Login/TutorialMobile";

export default function Login() {
  const [showTutorial, setShowTutorial] = useState(true);

  useEffect(() => {
    // Check if localStorage is available (client-side)
    if (typeof window !== "undefined") {
      const isTutorialViewed = localStorage.getItem("tutorialViewed");
      if (isTutorialViewed) {
        setShowTutorial(false);
      }
    }
  }, []);

  function handleCloseTutorial() {
    if (typeof window !== "undefined") {
      localStorage.setItem("tutorialViewed", "true");
    }
    setShowTutorial(false);
  }

  return (
    <main>
      <div className="hidden md:grid grid-cols-2 h-screen font-comfortaa">
        <LoginComponent />
        <TutorialDesktop />
      </div>
      <div className="hidden max-md:block h-screen">
        {showTutorial ? (
          <TutorialMobile handleCloseTutorial={handleCloseTutorial} />
        ) : (
          <LoginComponent />
        )}
      </div>
    </main>
  );
}
